import { Component, inject } from '@angular/core';
import { NgRedux, select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { validateFormElements } from '@ps20-frontend/utils';
import { NxIconComponent } from '@allianz/ng-aquila/icon';
import { NxCheckboxComponent } from '@allianz/ng-aquila/checkbox';
import { FormsModule } from '@angular/forms';
import { NxErrorComponent } from '@allianz/ng-aquila/base';
import { NxFormfieldErrorDirective } from '@allianz/ng-aquila/formfield';
import { NxButtonComponent } from '@allianz/ng-aquila/button';
import { AsyncPipe } from '@angular/common';
import { TextPipe, HtmlPipe } from '@ps20-frontend/text-service';
import { vnAddressInvalidConfirmed } from '../../store/local.actions';
import { IAppState } from '../../store/localStore';
import { selectCorrelationId } from '../../store/selectors/saveProtocol.selector';

@Component({
  selector: 'ps20-shop-vn-address-invalid',
  templateUrl: './vn-address-invalid.component.html',
  imports: [
    NxIconComponent,
    NxCheckboxComponent,
    FormsModule,
    NxErrorComponent,
    NxFormfieldErrorDirective,
    NxButtonComponent,
    AsyncPipe,
    TextPipe,
    HtmlPipe,
  ],
})
export class VnAddressInvalidComponent {
  private readonly ngRedux = inject<NgRedux<IAppState>>(NgRedux);

  @select(selectCorrelationId) correlationId: Observable<string>;

  checkboxChecked = false;

  constructor() {}

  onGoToShopClick(): void {
    validateFormElements('vn-address-invalid');
    if (this.checkboxChecked) {
      this.ngRedux.dispatch(vnAddressInvalidConfirmed());
    }
  }
}
